import { ChevronRight } from "lucide-react";
import React from "react";

interface AwardItemProps {
  iconUrl: string;
  points: string;
  description: React.ReactNode;
  link?: { href: string; label: string };
}

export const AwardItem: React.FC<AwardItemProps> = ({ iconUrl, points, description, link }) => (
  <div className="w-full sm:w-1/2 px-1 md:flex md:items-center md:my-2">
    <div className="p-3 flex items-start rounded shadow w-full bg-white md:border-b md:border-gray-200 md:h-22 border border-gray-200">
      <div className="flex items-center justify-center self-center min-w-[24px] bg-holos-dark rounded-full p-3">
        <img src={iconUrl} className="h-7 w-7" />
      </div>
      <div className="flex-1 pl-3 self-center">
        <p className="uppercase font-bold text-md mb-1">{points}</p>
        <p className="text-gray-700 text-sm font-medium">{description}</p>
        {link && (
          <a href={link.href} className="flex items-center text-holos-dark text-xs mt-1 font-medium">
            <span>{link.label}</span>
            <ChevronRight className="ml-2" />
          </a>
        )}
      </div>
    </div>
  </div>
);
